import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'classesStudents.title',
    defaultMessage: 'Classes and Students',
  },
  deliver: {
    id: 'classesStudents.deliver',
    defaultMessage: 'Application date',
  },
  delete: {
    id: 'classesStudents.delete',
    defaultMessage: 'Delete',
  },
  edit: {
    id: 'classesStudents.edit',
    defaultMessage: 'Edit',
  },
  status: {
    id: 'classesStudents.status',
    defaultMessage: 'Status',
  },
  status_1: {
    id: 'classesStudents.status_1',
    defaultMessage: '1',
  },
  application_bimonthly: {
    id: 'classesStudents.application.bimonthly',
    defaultMessage: 'Bimonthly',
  },
  application: {
    id: 'classesStudents.application',
    defaultMessage: 'Application',
  },
  to: {
    id: 'classesStudents.to',
    defaultMessage: 'to',
  },
  schoolName: {
    id: 'classesStudents.schoolName',
    defaultMessage: 'School: {schoolName}',
  },
  studentsCount: {
    id: 'classesStudents.studentsCount',
    defaultMessage: '{studentsCount} students',
  },
  period: {
    id: 'classesStudents.period',
    defaultMessage: 'Period: {period}',
  },
  removeGroup: {
    id: 'classesStudents.removeGroup',
    defaultMessage: 'Remove Group',
  },
  removeGroupConfirmation: {
    id: 'classesStudents.removeGroupConfimation',
    defaultMessage: 'Remove this group?',
  },
  cancel: {
    id: 'classesStudents.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'classesStudents.continue',
    defaultMessage: 'Continue',
  },
  fallback: {
    id: 'classesStudents.fallback',
    defaultMessage: '[not defined]',
  },
  filterSchool: {
    id: 'classesStudents.filterSchool',
    defaultMessage: 'School',
  },
  filterLevel: {
    id: 'classesStudents.filterLevel',
    defaultMessage: 'Level',
  },
  filterPeriod: {
    id: 'classesStudents.filterPeriod',
    defaultMessage: 'Period',
  },
  errorMessageAnswerRegistered: {
    id: 'classesStudents.errorMessageAnswerRegistered',
    defaultMessage: 'Its not possible to delete the group, theres answer registered by students',
  },
  notify: {
    id: 'classesStudents.notify',
    defaultMessage: 'Notify students',
  },
  close: {
    id: 'classesStudents.close',
    defaultMessage: 'Close',
  },
  notifyStudentConfirmation: {
    id: 'classesStudents.notifyStudentConfirmation',
    defaultMessage: 'Emails sent successfully',
  },
});
